module.exports = __webpack_public_path__ + "static/ITSEC-6e4af8552eb32e102dece7e256b889a2.jpeg";